// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ViewConfirmDocument_wrapper__2Mb7r","file":"ViewConfirmDocument_file__1hJnU","size":"ViewConfirmDocument_size__1IMRO"};